import {Base,Axios} from "@/api/Base"

export class PaymentDownPersistency extends Base {

    path = "payment/downPersistency";
    download(param = {}) {
        return Axios.post(this.path, param, { responseType: "blob" })
    }
}